var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClappingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.083,
    height: 40.059,
    viewBox: "0 0 40.083 40.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clapping",
    transform: "translate(0 -0.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276206",
    "data-name": "Path 276206",
    d: "M60.43,166.016l-3.9,2.253a2.25,2.25,0,0,0-2.246-3.9l-5.919,3.417-3.173,1.832a3,3,0,0,0,1.048-4.183,1.484,1.484,0,0,0-2-.465l-2.6,1.5-3.619,2.089a11.462,11.462,0,0,0-4.654,15.051,11.239,11.239,0,0,0,15.628,4.6l11.692-6.748a2.336,2.336,0,0,0,.992-3.031,2.25,2.25,0,0,0-3.132-.929l3.676-2.123a2.336,2.336,0,0,0,.993-3.033,2.249,2.249,0,0,0-3.131-.93l2.488-1.436a2.335,2.335,0,0,0,.991-3.03,2.25,2.25,0,0,0-3.132-.93Zm0,0",
    transform: "translate(-29.328 -149.578)",
    fill: "#fec000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276207",
    "data-name": "Path 276207",
    d: "M200.851,209.328l-9.11,5.259a.7.7,0,1,1-.7-1.217l9.11-5.259a.7.7,0,0,1,.7,1.217Zm0,0",
    transform: "translate(-173.928 -189.665)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276208",
    "data-name": "Path 276208",
    d: "M249.584,314.336l-6.627,3.826a.7.7,0,1,1-.7-1.217l6.627-3.826a.7.7,0,0,1,.7,1.217Zm0,0",
    transform: "translate(-220.643 -285.446)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276209",
    "data-name": "Path 276209",
    d: "M227.765,245.1l-10.414,6.012a.7.7,0,1,1-.7-1.217l10.414-6.012a.7.7,0,0,1,.7,1.217Zm0,0",
    transform: "translate(-197.288 -222.299)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276210",
    "data-name": "Path 276210",
    d: "M112.306,224.641l-5.218,3.012a.7.7,0,0,1-.7-1.217l5.218-3.012a.7.7,0,1,1,.7,1.217Zm0,0",
    transform: "translate(-96.721 -203.629)",
    fill: "#d9a600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87745",
    "data-name": "Group 87745",
    transform: "translate(9.142 0.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276211",
    "data-name": "Path 276211",
    d: "M388.754,29.862a.7.7,0,0,1-.5-1.2l4.569-4.569a.7.7,0,1,1,.994.994l-4.569,4.569A.7.7,0,0,1,388.754,29.862Zm0,0",
    transform: "translate(-363.095 -21.788)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276212",
    "data-name": "Path 276212",
    d: "M400.748,91.424a.7.7,0,0,1-.363-1.305L403.9,88.01a.7.7,0,1,1,.724,1.2l-3.515,2.109A.7.7,0,0,1,400.748,91.424Zm0,0",
    transform: "translate(-374.034 -80.186)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276213",
    "data-name": "Path 276213",
    d: "M352.758,29.6a.7.7,0,0,1-.628-1.017l2.109-4.218a.7.7,0,1,1,1.258.628l-2.109,4.218A.7.7,0,0,1,352.758,29.6Zm0,0",
    transform: "translate(-330.262 -21.874)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276214",
    "data-name": "Path 276214",
    d: "M146.9,6.4a.7.7,0,0,1-.646-.426l-2.109-4.921A.7.7,0,0,1,145.438.5l2.109,4.921a.7.7,0,0,1-.646.98Zm0,0",
    transform: "translate(-140.574 -0.082)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276215",
    "data-name": "Path 276215",
    d: "M200.754,13.6a.7.7,0,0,1-.7-.7V8.68a.7.7,0,0,1,1.406,0V12.9A.7.7,0,0,1,200.754,13.6Zm0,0",
    transform: "translate(-191.614 -7.283)",
    fill: "#aeadb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276216",
    "data-name": "Path 276216",
    d: "M107.554,36.9a.7.7,0,0,1-.55-.264l-2.812-3.515a.7.7,0,0,1,1.1-.879l2.812,3.515a.7.7,0,0,1-.548,1.142Zm0,0",
    transform: "translate(-104.038 -29.173)",
    fill: "#aeadb3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_276217",
    "data-name": "Path 276217",
    d: "M24.435,108.775l-3.187,3.187a2.25,2.25,0,1,0-3.179-3.185l-4.832,4.833L10.647,116.2a3,3,0,0,0-.07-4.311,1.483,1.483,0,0,0-2.051.07L6.4,114.078l-2.956,2.957a11.455,11.455,0,0,0-.6,15.741,11.241,11.241,0,0,0,16.285.394l9.546-9.546a2.335,2.335,0,0,0,.173-3.184,2.249,2.249,0,0,0-3.265-.088l3-3a2.335,2.335,0,0,0,.174-3.184,2.25,2.25,0,0,0-3.265-.089l2.032-2.031a2.337,2.337,0,0,0,.173-3.185,2.25,2.25,0,0,0-3.265-.088Zm0,0",
    transform: "translate(0 -98.541)",
    fill: "#ffe670"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276218",
    "data-name": "Path 276218",
    d: "M152.071,151.012l-7.438,7.438a.7.7,0,0,1-.994-.994l7.438-7.438a.7.7,0,0,1,.994.994Zm0,0",
    transform: "translate(-130.838 -136.582)",
    fill: "#ebb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276219",
    "data-name": "Path 276219",
    d: "M222.276,246.5l-5.413,5.413a.7.7,0,1,1-.994-.994l5.413-5.413a.7.7,0,0,1,.994.994Zm0,0",
    transform: "translate(-196.705 -223.679)",
    fill: "#ebb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276220",
    "data-name": "Path 276220",
    d: "M189.23,175.008l-8.506,8.506a.7.7,0,0,1-.994-.994l8.505-8.506a.7.7,0,1,1,.995.994Zm0,0",
    transform: "translate(-163.749 -158.461)",
    fill: "#ebb300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276221",
    "data-name": "Path 276221",
    d: "M64.308,199.063l-4.261,4.261a.7.7,0,1,1-.994-.995l4.258-4.26a.7.7,0,1,1,.994.994Zm0,0",
    transform: "translate(-53.677 -180.395)",
    fill: "#ebb300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClappingIcon);
export default __webpack_public_path__ + "static/media/Clapping_Icon.db36b6ba68e29f94ed81d231d5b491ed.svg";
export { ForwardRef as ReactComponent };